/**
 * ConfirmDialog — подтверждение деструктивного действия (отмена/удаление транша).
 * Кнопка подтверждения — danger; поддерживает состояние pending и текст ошибки.
 */

import { Dialog } from '../ui/Dialog';
import { Button } from '../ui/Button';

export interface ConfirmDialogProps {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  danger?: boolean;
  pending?: boolean;
  error?: string | null;
  onConfirm: () => void;
  onClose: () => void;
}

export function ConfirmDialog({
  title,
  message,
  confirmLabel,
  cancelLabel = 'Отмена',
  danger = true,
  pending = false,
  error,
  onConfirm,
  onClose,
}: ConfirmDialogProps): JSX.Element {
  return (
    <Dialog
      title={title}
      onClose={onClose}
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={pending}>
            {cancelLabel}
          </Button>
          <Button variant={danger ? 'danger' : 'primary'} onClick={onConfirm} disabled={pending}>
            {pending ? 'Выполняется…' : confirmLabel}
          </Button>
        </>
      }
    >
      <p className="pw-dialog__text">{message}</p>
      {error ? (
        <p className="pw-field__err" role="alert">
          {error}
        </p>
      ) : null}
    </Dialog>
  );
}
